<template>
  <div
    class="show-status"
  >
    &#11044;
    <q-tooltip v-if="hasDefaultSlot">
      <slot></slot>
    </q-tooltip>
  </div>
</template>

<script>
export default {
  computed: {
    hasDefaultSlot() {
      return !!this.$slots.default;
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~variables';
.show-status {
  line-height: 38px;
  margin-right: 5px;
  color: $ctrl-red;

  &--green {
    color: $ctrl-turquoise;
  }
  &--orange {
    color: $ctrl-orange;
  }
  &--yellow {
    color: $ctrl-yellow;
  }
}
</style>
